class ReportBlockService {
  getTheRightConfiguration (configFromDataset, configFromLayout) {
    let configFromDatasetLength = 0
    let configFromLayoutLength = 0

    if (Array.isArray(configFromDataset)) {
      configFromDatasetLength = configFromDataset.length
    } else if ((typeof configFromDataset === 'object') && (configFromDataset !== null)) {
      configFromDatasetLength = Object.keys(configFromDataset).length
    }

    if (Array.isArray(configFromLayout)) {
      configFromLayoutLength = configFromLayout.length
    } else if ((typeof configFromLayout === 'object') && (configFromLayout !== null)) {
      configFromLayoutLength = Object.keys(configFromLayout).length
    }

    if (configFromDataset && (
      ((!configFromLayout || configFromLayoutLength === 0) && (configFromDatasetLength > 0)) ||
      ((configFromLayout && configFromLayoutLength > 0) && (configFromLayoutLength !== configFromDatasetLength))
    )) {
      return configFromDataset
    } else {
      return configFromLayout
    }
  }
}

export const reportBlockService = new ReportBlockService()
